import isValid from 'date-fns/isValid'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

const dateIsValid = (dateProp: dateParamType) => {
  let result: boolean
  try {
    const date = toDate(dateProp)
    result = isValid(date)
  } catch {
    result = false
  }
  return result
}

export default dateIsValid
